import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useLocation } from "react-router-dom";
import { LogOut, Menu, X } from "lucide-react";

const PAGE_TITLES = {
  "/dashboard": "Dashboard",
  "/users": "Users",
  "/master-data/warehouses": "Warehouses",
  "/leads": "Leads",
  "/leads/all": "All Leads",
  "/leads/active": "Active Leads",
  "/leads/confirmed": "Confirmed Leads",
  "/leads/closed": "Closed Leads",
  "/bookings": "Bookings",
};

export default function Header({ onToggle, collapsed }) {
  const { user, logout } = useAuth();
  const location = useLocation();

  const getTitle = (pathname) => {
    if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
    if (pathname.startsWith("/leads/")) return "Lead Detail";
    return "Portal";
  };

  const title = getTitle(location.pathname);

  const initials = (user?.name || "U")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const roleLabel = user?.role?.replace(/_/g, " ") || "";

  return (
    <header className="h-16 bg-white border-b border-[#E2E8F0] flex items-center justify-between px-6 sticky top-0 z-30">
      {/* Left: toggle + title */}
      <div className="flex items-center gap-4">
        <button
          onClick={onToggle}
          data-testid="sidebar-toggle-btn"
          className="text-[#475569] hover:text-[#1B2A6B] transition-colors p-1 -ml-1"
        >
          {collapsed ? <Menu size={20} /> : <X size={20} />}
        </button>
        <h1 className="text-base font-bold text-[#1B2A6B] tracking-wide">{title}</h1>
      </div>

      {/* Right: user info + logout */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-full bg-[#1B2A6B] flex items-center justify-center shrink-0">
            <span className="text-xs font-bold text-[#FFD700]">{initials}</span>
          </div>
          <div className="hidden sm:block leading-tight">
            <p className="text-sm font-semibold text-[#0F172A]">{user?.name}</p>
            <p className="text-xs text-[#475569] capitalize">{roleLabel}</p>
          </div>
        </div>

        <div className="w-px h-7 bg-[#E2E8F0] mx-1" />

        <button
          data-testid="logout-button"
          onClick={logout}
          className="flex items-center gap-1.5 text-xs font-semibold text-[#475569] hover:text-red-600 hover:bg-red-50 transition-colors py-1.5 px-2 rounded-sm"
        >
          <LogOut size={14} />
          <span className="hidden sm:inline">Sign Out</span>
        </button>
      </div>
    </header>
  );
}
